import React, { useState } from "react";
// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { vscDarkPlus } from "react-syntax-highlighter/dist/cjs/styles/prism";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { IconButton } from "@mui/material";
import "./PulseCode.scss";

interface PulseCodeProps {
  children: string;
  language?: string;
  className?: string;
  showLineNumbers?: boolean;
  filename?: string;
}

const PulseCode: React.FC<PulseCodeProps> = ({
  children,
  // language = "javascript",
  className = "",
  // showLineNumbers = true,
  filename,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(children);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
  };

  return (
    <div className={`pulse-code ${className}`}>
      {filename && <div className="filename">{filename}</div>}
      <div className="code-container">
        <div className="code-header">
          <IconButton onClick={handleCopy} className="copy-button">
            {copied ? (
              <CheckIcon fontSize="small" />
            ) : (
              <ContentCopyIcon fontSize="small" />
            )}
          </IconButton>
        </div>
        <div className="code-content">
          <pre>{children}</pre>
        </div>
      </div>
      {/* <SyntaxHighlighter
        language={language}
        style={vscDarkPlus}
        showLineNumbers={showLineNumbers}
        customStyle={{
          margin: 0,
          borderRadius: "8px",
          fontSize: "14px",
        }}
      >
        {children}
      </SyntaxHighlighter> */}
    </div>
  );
};

export default PulseCode;
